export class BonusScreenMessage {}
